<template>
  <div class="contain">
    <div class="enr_con">
       <div class="imgurl"> <img src="../assets/images/22.png" alt=""> </div>
      <p class="navigation fl">您当前所在的位置：
        <router-link to="/home/index" class="home">首页</router-link>&nbsp;>&nbsp;<a href="javascript:;" style="color:#666">录取查询</a>
      </p>
      <div class="main">
        <left-comp></left-comp>
        <div class="enr_right">
         
          <div class="tab-bd  enroll">
            <p class="tit">池州职业技术学院录取查询</p>
            <form id="" method="post" class="queryform">
              <div class="input_con">
                <label>姓名</label>
                <!--姓名框-->
                <input type="text" placeholder="请输入姓名"
                       @blur="checkPwd"
                       :class="{red:isRedp}"
                       @keyup.enter="_login"
                       class="inputform fr"
                       v-model="xm">
              </div>
              <!--身份证号框-->
              <div class="input_con">
                <label>身份证号</label>
                <input type="text"
                       :class="{red:isRedu}"
                       placeholder="请输入身份证号码"
                       @blur="checkUser"
                       @keyup.enter="_login"
                       class="inputform fr"
                       v-model="sfzjh">
              </div>
              <div class="formbutton"><a href="javascript:;" class="btn" @click="_admitSearch()">查&nbsp;&nbsp;询</a></div>
            </form>
              <div class="clear"></div>
            </div>


          <!--有数据时展示此内容-->
          <div class="tab-bd  enroll" v-if="cardFlag">
                   <table border="1 " class="formcontent score mt30">
              <tr>
                <th width="25% " colspan="4">高职考试录取结果</th>
              </tr>
              <tr>
                <td width="33%" align="center"> 考试成绩</td>
                <td align="center">{{data.score}}</td>
              </tr>
              <tr>
                <td width="33%" align="center"> 报考院系</td>
                <td align="center">{{data.wish_dept}}</td>
              </tr>
              <tr>
                <td width="25%" align="center"> 报考专业</td>
                <td align="center">{{data.wish_zymc}}</td>
              </tr>
              <tr>
                <td width="25%" align="center"> 录取结果</td>
                <td align="center">已录取</td>
              </tr>
              <tr>
                <td width="25%" align="center">录取专业</td>
                <td align="center">{{data.zymc}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <tip :tip="tip" v-show="tipShow"></tip>
  </div>
</template>

<script>
import leftComp from "../components/leftComp";
import { admitSearch } from "../api/updata";

export default {
  components: { leftComp },
  data() {
    return {
      cardFlag: false, //数据框显示隐藏
      xm: "",
      sfzjh: "", //姓名、身份证号码
      isRedp: false,
      isRedu: false, //绑定class
      tip: "",
      tipShow: false, //提示框
      data: {} //保存成绩数据
    };
  },

  created() {
    this.sfzjh = JSON.parse(
      this.global.Base64.decode(sessionStorage.getItem("INFO"))
    ).sfzjh; //身份证
    this.xm = JSON.parse(
      this.global.Base64.decode(sessionStorage.getItem("INFO"))
    ).xm; //姓名
  },
  methods: {
    // 搜索按钮
    _admitSearch() {
      if (this.sfzjh == null || this.xm == null) {
        this.loading = false;
        this.tipCtr("学生信息缺失");
      } else if (this.checkUser() && this.checkPwd()) {
        let module = {
          sfzjh: this.global.Base64.encode(this.sfzjh),
          xm: this.xm
        };
        admitSearch(module)
          .then(res => {
            if (res.status) {
              this.cardFlag = true;
              this.data = res.data;
            } else {
              this.tipCtr(res.msg);
              this.cardFlag = false;
            }
          })
          .catch(err => {
            this.tipCtr("未找到相关数据,请重新加载");
          });
      } else {
        this.checkPwd() && this.checkPwd();
      }
    },
    //验证用户名
    checkUser() {
      let reg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
      //判断手机号是否存在
      if (!this.sfzjh) {
        this.isRedu = true;
        this.tipCtr("请输入身份证号码");
        return false;
      } else if (!reg.test(this.sfzjh)) {
        this.isRedu = true;
        this.tipCtr("请输入正确的身份证号码");
        return false;
      } else {
        this.isRedu = false;
        return true;
      }
    },

    // 验证用户名密码
    checkPwd() {
      let reg = /^[\u4E00-\u9FA5\uf900-\ufa2d]{2,4}$/;
      if (!this.xm) {
        this.isRedp = true;
        this.tipCtr("请输入姓名");
        return false;
      } else if (!reg.test(this.xm)) {
        this.tipCtr("请输入正确的姓名");
        this.isRedp = true;
      } else {
        this.isRedp = false;
        return true;
      }
    },

    //tip控制方法
    tipCtr(text) {
      this.tip = text;
      this.tipShow = true;
      setTimeout(() => {
        this.tipShow = false;
      }, 1500);
    }
  }
};
</script>

<style scoped>
input.red {
  border: 1px solid red !important;
}
.enr_right {
  width: 100%;
  border-radius: 4px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px 0 #e0e0e0;
}
.btn {
  margin-top: 30px;
}

.tit {
  padding-left: 20px;
  font-size: 22px;
  letter-spacing: 0.77px;
  color: #333333;
  font-weight: bold;
}
.input_con label {
  height: 32px;
  line-height: 32px;
  float: left;
  padding-right: 1rem;
  font-size: 0.9rem;
  color: #666;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/view/query.vue